import { useRouter } from "next/router";

import HeadSeo from "@components/HeadSeo/HeadSeo";
import Container from "@ui-kit/Container/Container";
import { addBlankAttrToHtml } from "@utils/utils";

import s from "./TicketSalesRules.module.scss";

const TicketSalesRules = ({ data }) => {
  const { locale } = useRouter();
  const { article } = data;

  let seo = {
    et: {
      title: "Lux Expressi reisijate- ja pagasiveo eeskirjad",
      description: "Eeskirjad reisijate ja pagasi veoks Lux Expressi bussides.",
      socialTitle: "Lux Expressi reisijate- ja pagasiveo eeskirjad",
      socialDescription:
        "Eeskirjad reisijate ja pagasi veoks Lux Expressi bussides.",
      pageKeywords: "",
      thumbnail:
        "/static/images/thumbnails/transportation-rules/Lux_Express_transportation_rules.jpg",
    },
    en: {
      title: "Lux Express passenger and luggage transportation rules",
      description:
        "Rules for carriage of passengers and luggage on Lux Express coaches.",
      socialTitle: "Lux Express passenger and luggage transportation rules",
      socialDescription:
        "Rules for carriage of passengers and luggage on Lux Express coaches.",
      pageKeywords: "",
      thumbnail:
        "/static/images/thumbnails/transportation-rules/Lux_Express_transportation_rules.jpg",
    },
    lt: {
      title: "Lux Express passenger and luggage transportation rules",
      description:
        "Rules for carriage of passengers and luggage on Lux Express coaches.",
      socialTitle: "Lux Express passenger and luggage transportation rules",
      socialDescription:
        "Rules for carriage of passengers and luggage on Lux Express coaches.",
      pageKeywords: "",
      thumbnail:
        "/static/images/thumbnails/transportation-rules/Lux_Express_transportation_rules.jpg",
    },
    lv: {
      title: "Lux Express passenger and luggage transportation rules",
      description:
        "Rules for carriage of passengers and luggage on Lux Express coaches.",
      socialTitle: "Lux Express passenger and luggage transportation rules",
      socialDescription:
        "Rules for carriage of passengers and luggage on Lux Express coaches.",
      pageKeywords: "",
      thumbnail:
        "/static/images/thumbnails/transportation-rules/Lux_Express_transportation_rules.jpg",
    },
    ru: {
      title: "Lux Express passenger and luggage transportation rules",
      description:
        "Rules for carriage of passengers and luggage on Lux Express coaches.",
      socialTitle: "Lux Express passenger and luggage transportation rules",
      socialDescription:
        "Rules for carriage of passengers and luggage on Lux Express coaches.",
      pageKeywords: "",
      thumbnail:
        "/static/images/thumbnails/transportation-rules/Lux_Express_transportation_rules.jpg",
    },
    pl: {
      title: "Lux Express passenger and luggage transportation rules",
      description:
        "Rules for carriage of passengers and luggage on Lux Express coaches.",
      socialTitle: "Lux Express passenger and luggage transportation rules",
      socialDescription:
        "Rules for carriage of passengers and luggage on Lux Express coaches.",
      pageKeywords: "",
      thumbnail:
        "/static/images/thumbnails/transportation-rules/Lux_Express_transportation_rules.jpg",
    },
  };

  seo = seo[locale];
  seo.articlePublishedTime = article?.createdAt || "";
  seo.articleModifiedTime = article?.editedAt || "";

  return (
    <div className={s.ticketSalesRules}>
      <HeadSeo seo={seo} />
      <Container>
        <Container full={false}>
          <section>
            <h1 className={s.title}>{article.title}</h1>
            {article.body && (
              <div
                className={s.article}
                dangerouslySetInnerHTML={{
                  __html: addBlankAttrToHtml(article.body),
                }}
              />
            )}
          </section>
        </Container>
      </Container>
    </div>
  );
};

export default TicketSalesRules;
